

















import Vue from 'vue';
import commonClient from '../apis';
import commonVuex from '../vuex/common';
import Task from '../models/Task';
import TaskItem from './TaskItem.vue';

export default Vue.extend({
  mixins: [commonVuex],
  components: {
    TaskItem,
  },
  data() {
    return {
      interval: null,
      page: 1,
      total: 0,
    };
  },
  methods: {
    setConfirmed() {
      commonClient.setConfirmedTasks();
    },
    loadTasks() {
      commonClient.getAllTasks({
        page: this.page,
        size: 30,
      }).success(r => {
        this.total = r.total;
        this.$store.commit('SET_TASKS', r.tasks);
      });
    },
    onPageChange(page: number) {
      this.page = page;
      this.loadTasks();
    },
  },
  mounted() {
    this.setConfirmed();
    this.loadTasks();
    this.interval = setInterval(() => {
      this.loadTasks();
    }, 5000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
});
